module.exports = __webpack_public_path__ + "media/dog-weight/dalmatian-white-df443ff1.svg";